import { organizationEndpoints } from '@/api/endpoints';
import type { FetcherService } from '@/services/abstract/FetcherService';
import { OrganizationService } from '@/services/abstract/OrganizationService';
import type { CoturnCredentials } from '@/types/organization/CoturnCredentials';

export class OrganizationServiceImpl extends OrganizationService {
  constructor(private readonly fetcher: FetcherService) {
    super();
  }

  async getCoturnCredentials(organizationId: string): Promise<CoturnCredentials> {
    return await this.fetcher.get<CoturnCredentials>(
      organizationEndpoints.getCoturnCredentials(organizationId)
    );
  }
}
